import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import type { OutreachPitchKind } from 'fym-shared/src/music24/outreach/dailyPitches';
import { TypedMemo } from '../../../common/types';
import { SAMPLE_KIND_TAB } from './sampleKindCopy';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SampleKindTabsProps {
  kinds: OutreachPitchKind[];
  selected: OutreachPitchKind | null;
  onSelect: (kind: OutreachPitchKind) => void;
}

/** One tab for each kind of the campaign (design outreach-v2 d1). No tab for one kind or none. */
const SampleKindTabsComponent: React.FC<SampleKindTabsProps> = ({ kinds, selected, onSelect }) => {
  const intl = useIntl();
  if (kinds.length < 2) {
    return null;
  }
  return (
    <div className={shared.row} role="tablist" data-testid="sample-kind-tabs">
      {kinds.map((kind) => (
        <button
          key={kind}
          type="button"
          role="tab"
          aria-selected={kind === selected}
          className={clsx(shared.chip, shared.chipButton, kind === selected && shared.chipOn)}
          onClick={() => onSelect(kind)}
        >
          {intl.formatMessage(SAMPLE_KIND_TAB[kind])}
        </button>
      ))}
    </div>
  );
};

export const SampleKindTabs = TypedMemo(SampleKindTabsComponent);
